import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const InstructionsPopUp = ({ open, close }) => {
    return (
        <Modal show={open} onHide={close} centered backdrop="static" size="lg">
            <Modal.Header 
            style={{
            backgroundColor: "rgb(255, 204, 1)",
            color: "rgb(5, 88, 55)"
            }}
            >
                <Modal.Title>Important Notice</Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-3">
                    <p>
                    As per latest TRA{" "}
                    <Link to="https://www.tradesrecognitionaustralia.gov.au/offshore-skillsassessmentprogram-osap/offshore-skills-assessment-program-applicant-guidelines"style={{ textDecoration: 'underline' , color : "blue"}}>
                        OSAP
                    </Link>{" "}
                    &{" "}
                    <Link to="https://www.tradesrecognitionaustralia.gov.au/programs-tss-skills-assessment/guidelines" style={{ textDecoration: 'underline' , color : "blue"}}>
                        TSS
                    </Link>{" "}
                    
                    Guidelines (June 2025), applicants must remove or cover Tax File Numbers (TFN),
                    bank account details, or any other sensitive and personal information before
                    submitting documents.
                    </p>
                    <p><b><u>
                        If sensitive information is included, we will request the
                    corrected documents which can cause delays in processing of the application.
                    </u></b></p>
            </Modal.Body>


            <Modal.Footer className="d-flex justify-content-center">
                <Button
                    className='btn btn_green_yellow'
                    onClick={close}
                    style={{ minWidth: "100px" }}
                >
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InstructionsPopUp;
